import { TheWestSection } from '@news-mono/common'
import {
    ArticleAvailableEvent,
    EntitledToView,
    ImageSourceWithCaptions,
    PublicationEvents,
    PublicationType,
    RequiredAccess,
    useToggleState,
} from '@news-mono/web-common'
import H from 'history'
import React, { Fragment } from 'react'
import { Logger } from 'typescript-log'
import { useSection } from '../..'
import {
    BreachNotificationWrapper,
    BreachWallContentType,
    useBreachWallConfig,
} from './components/BreachNotificationWrapper/BreachNotificationWrapper'
import { checkIsRegional } from './components/SubscriptionPackage/SubscriptionPackage'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'
import {
    StyledGalleryBreach,
    StyledGalleryBreachNotification,
} from './GalleryBreach.styled'

interface GalleryProps {
    requiredAccess: RequiredAccess
    location: H.Location
    images: ImageSourceWithCaptions[]
    onEvent: (event: PublicationEvents | ArticleAvailableEvent) => void
    children: (
        content: {
            images: ImageSourceWithCaptions[]
        },
        entitled: boolean,
    ) => React.ReactElement<any>
    gallery: PublicationType
    slug: string
    log: Logger
}

export const GalleryBreach: React.FC<GalleryProps> = (props) => {
    const {
        requiredAccess,
        location,
        images,
        onEvent,
        children,
        gallery,
        slug,
        log,
    } = props

    const { creativeName, deal, type } = useBreachWallConfig(location)

    const section = useSection<TheWestSection>()

    const isRegional = checkIsRegional(section)

    // ABTEST : Configure the breach deals here to override all breach deals
    //AB Test parameters
    const abTestVariation = useToggleState()?.['breach-ab-test-1'] || 'a'

    let abBreachDeal: string | undefined
    let abBreachType: BreachWallContentType

    if (abTestVariation && !isRegional) {
        if (abTestVariation === 'a') {
            abBreachDeal = deal
            abBreachType = type
        }
        if (abTestVariation === 'b') {
            abBreachDeal = 'DIG1X4'
            abBreachType = 'abtest-b-1x4'
        }
        if (abTestVariation === 'c') {
            abBreachDeal = 'DIG50CX8'
            abBreachType = 'abtest-c-50cx8'
        }
        if (abTestVariation === 'd') {
            abBreachDeal = 'DIG50X8'
            abBreachType = 'abtest-d-50px8'
        }
    }

    return (
        <EntitledToView
            requiredAccess={requiredAccess}
            articleSlug={slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                creativeName,
                deal,
                location,
                onEvent,
                gallery,
            )}
            entitled={() => {
                return children({ images }, true)
            }}
            notEntitled={() => {
                const { children } = props
                return (
                    <Fragment>
                        <StyledGalleryBreach>
                            {children({ images: [] }, false)}
                        </StyledGalleryBreach>
                        <StyledGalleryBreachNotification>
                            <BreachNotificationWrapper
                                publication={gallery}
                                requiredAccess={requiredAccess}
                                breachDeal={abBreachDeal ? abBreachDeal : deal}
                                breachCreativeName={creativeName}
                                onEvent={onEvent}
                                type={abBreachType ? abBreachType : type}
                                blocks={[]}
                                log={log}
                            />
                        </StyledGalleryBreachNotification>
                    </Fragment>
                )
            }}
        />
    )
}

GalleryBreach.displayName = 'GalleryBreach'
